export default __webpack_public_path__ + "static/media/MyRiadPro-Bold.24292333.OTF";